var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArmArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73333 3.50166L1.28 0.16166C0.752611 -0.233882 0 0.142424 0 0.80166V6.60166C0 7.2609 0.752611 7.6372 1.28 7.24166L5.73333 3.90166C5.86667 3.80166 5.86667 3.60166 5.73333 3.50166Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArmArrowBlack);
export default __webpack_public_path__ + "static/media/rightArmArrowBlack.bbca4318d0b5709bd8411f2aea7951a1.svg";
export { ForwardRef as ReactComponent };